import * as React from "react";
import Card, { CardProps } from "@mui/joy/Card";
import Typography from "@mui/joy/Typography";
import AspectRatio from "@mui/joy/AspectRatio";
import { useDropzone } from "react-dropzone";

import FileUploadRoundedIcon from "@mui/icons-material/FileUploadRounded";

interface DropZoneProps extends CardProps {
  icon?: React.ReactElement;
  onFileSelected: (file: File) => void;
}

const DropZone: React.FC<DropZoneProps> = ({
  icon,
  onFileSelected,
  sx,
  ...other
}) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles: File[]) => {
      if (acceptedFiles && acceptedFiles.length > 0) {
        onFileSelected(acceptedFiles[0]);
      }
    },
    accept: {
      "image/png": [".png"],
      "image/jpeg": [".jpg", ".jpeg"],
    },
    maxSize: 800 * 400, // max size in pixels
  });

  return (
    <div
      variant="outlined"
      {...other}
      style={{
        borderRadius: "sm",
        display: "flex",
        flexDirection: "column",
        gap: 1,
        alignItems: "center",
        flexGrow: 1,
        boxShadow: "none",
        cursor: 'pointer'
      }}
      {...getRootProps()}
    >
      <AspectRatio
        ratio="1"
        variant="solid"
        color="primary"
        sx={{
          minWidth: 32,
          borderRadius: "50%",
          "--Icon-fontSize": "16px",
        }}
      >
        <div>{icon ?? <FileUploadRoundedIcon />}</div>
      </AspectRatio>
      <Typography textAlign="center">
        Click to upload or drag and drop
        <br /> SVG, PNG, JPG or GIF (max. 800x400px)
      </Typography>
      <input {...getInputProps()} />
    </div>
  );
};

export default DropZone;
